export enum EditorType {
    TemplateEditor = 'TemplateEditor',
    CheckoutCreator = 'CheckoutCreator',
    LandingPageCreator = 'LandingPageCreator',
    PaidNewsletterCreator = 'PaidNewsletterCreator',
};
